export default __webpack_public_path__ + "static/ethan-b9db924e60d8a96643da69e15402a66f.png";